import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { motion } from 'framer-motion';

export default function ThemeToggle({ dark, setDark }) {
  return (
    <button
      data-testid="theme-toggle"
      onClick={() => setDark(!dark)}
      className="relative w-9 h-9 rounded-full flex items-center justify-center text-[#6B6561] dark:text-[#9B9590] hover:bg-[#EAE4DA] dark:hover:bg-[#3D3A37] transition-colors"
      aria-label={dark ? 'Activează modul luminos' : 'Activează modul întunecat'}
    >
      <motion.div
        key={dark ? 'moon' : 'sun'}
        initial={{ scale: 0, rotate: -90 }}
        animate={{ scale: 1, rotate: 0 }}
        exit={{ scale: 0, rotate: 90 }}
        transition={{ duration: 0.2 }}
      >
        {dark ? <Sun size={18} /> : <Moon size={18} />}
      </motion.div>
    </button>
  );
}
